var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component"},[(_vm.value)?[_vm._v(_vm._s(_vm._f("moment")(_vm.value,'timezone', 'Europe/Minsk', _vm.format)))]:[_vm._v(_vm._s(_vm.$t(_vm.placeholder)))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }